
import React from "react"
import { Box, Dialog, Text, TextInput, Select, Textarea, Button, ActionList, Avatar } from '@primer/react'
import { useDispatch, useSelector } from "react-redux";
import { filesearchOpenClose, filteredFilesId } from '../../redux/features/searchSlice';
import Workplacetheme from "../Workplacetheme";
import { ArrowRightIcon, ExclamationTriangleIcon, MagnifyingGlassIcon } from "@radix-ui/react-icons";





function FilesSearchDialog(props) {

    const dispatch = useDispatch()
    const searchData = useSelector((state) => state.searchData)
    const spacefilesArray = useSelector((state) => state.spaceData.spacefilesArray) || []
    const initialFocusRef = React.createRef()


    const [filesArray, setfilesArray] = React.useState([...spacefilesArray])
    const [searchInput, setsearchInput] = React.useState("")
    const [showActionList, setshowActionList] = React.useState(false)
    const [showListCount, setshowListCount] = React.useState(0)

    const handleSearchInput = (e) => {

        setsearchInput(e.target.value)



        if (e.target.value.length > 0) {


            setfilesArray((prevState) => {

                const newState = prevState.filter((fData) => fData?.attachments?.attachment_file_name?.toUpperCase().includes(e.target.value.toUpperCase()))
                if (newState.length > 0) {
                    setshowActionList(true)
                    return newState
                } else if (newState.length == 0) {
                    setshowActionList(false)
                    return spacefilesArray
                }
            })


        } else {
            setshowActionList(false)

        }



    }

    const closeSearchDialog = (props) => {

        dispatch(filesearchOpenClose({
            fopenClose: false
        }))
        setsearchInput("")
        setshowActionList(false)
        setshowListCount(0)

    }


    return (
        <Dialog
            sx={Workplacetheme.filessearchDialogMain}
            isOpen={searchData.fopenClose}
            style={{ height: showListCount === 0 ? 51 : 170 }}
            onDismiss={() =>
                closeSearchDialog("")
            }
            aria-labelledby="header-id"
            initialFocusRef={initialFocusRef}

        >

            <Box sx={Workplacetheme.hideDialogCloseBtn}></Box>

            <TextInput
                ref={initialFocusRef}
                leadingVisual={
                    <MagnifyingGlassIcon
                        style={{
                            height: 20,
                            width: 16,
                            display: "flex",
                            alignContent: 'center'
                        }} />}
                sx={Workplacetheme.filesearchDialogInput}
                aria-label="SearchInput"
                name="searchInput"
                placeholder="Search your files"
                onChange={(e) => handleSearchInput(e)}
                value={searchInput}
            />



            {showActionList && (
                <ActionList showDividers sx={Workplacetheme.filesearchDialogActionList}>
                    {
                        filesArray.map((row, index) => {
                            return (

                                <ActionList.Item sx={Workplacetheme.filesearchDialogActionList.actionListItem}
                                    onSelect={(e) => {
                                        dispatch(filteredFilesId({
                                            filteredAttachmentId: row.attachments.attachment_id
                                        }))
                                        closeSearchDialog("")
                                    }}
                                >
                                    <Text sx={Workplacetheme.filesearchDialogActionList.actionListItem.textField}>
                                        {row.attachments?.attachment_file_name}</Text>
                                </ActionList.Item>
                            )
                        })
                    }
                </ActionList>


            )}

 

        </Dialog>
    )
}

export default FilesSearchDialog


